import React, { useState, useEffect } from "react";
import {
  Checkbox,
  TextField,
  Typography,
  FormControlLabel,
  Link,
} from "@material-ui/core";
import ActionButton from "../../components/ActionButton";
import { makeStyles } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import "filepond/dist/filepond.min.css";
import axios from "../../AxiosClient";
import Scheduler from "material-ui-cron";
import JobProgress from "../components/JobProgress";
import MaterialTable from "@material-table/core";
import DoneIcon from "@material-ui/icons/Done";
import ClearIcon from "@material-ui/icons/Clear";
import { useHistory } from "react-router-dom";
import AreYouSureDialog from "../../components/dialog/AreYouSureDialog";
import cronstrue from "cronstrue";
import CreateCronExpression from "./CreateCronExpression";

const useStyles = makeStyles((theme) => ({
  header: {
    marginBottom: 15,
    display: "flex",
  },
  container: {
    height: "100%",
    width: "100%",
  },
  flexContainer: {
    display: "flex",
  },
  inputFields: {
    display: "flex",
    flexDirection: "row",
  },
}));

function KnowledgeSourceCronSchedule(props) {
  const [saving, setSaving] = useState(false);
  const [pausing, setPausing] = useState(false);
  const [paused, setPaused] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const classes = useStyles();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [cronExpression, setCronExpression] = useState("");
  const [cronError, setCronError] = useState(null);
  const [scheduleName, setScheduleName] = useState("");
  const [scheduleDescription, setScheduleDescription] = useState("");
  const [schedule, setSchedule] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ksIds, setKsIds] = useState([]);
  const [deletionDialog, setDeletionDialog] = useState(false);
  const [updateDialog, setUpdateDialog] = useState(false);
  const [pauseDialog, setPauseDialog] = useState(false);
  const [isFullReindex, setIsFullReindex] = useState(false);
  const [createCronExpressionOpen, setCreateCronExpressionOpen] = useState(
    false
  );
  const history = useHistory();

  useEffect(() => {
    axios.get("/knowledgesource/",{ withCredentials:true }).then((res) => {
      let data = res.data.content.filter((ks) => {
        return ks.type !== "EXPERT";
      });
      setData(
        data.map((i) => {
          return { id: i.sourceId, data: i };
        })
      );
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    props.default
      ? axios.get(`/knowledgesource/batchreindex/default`,{ withCredentials:true }).then((res) => {
          setSchedule(res.data);
          setScheduleName(res.data.scheduleName);
          setScheduleDescription(res.data.scheduleDescription);
          setCronExpression(res.data.cronExpression);
          setKsIds(res.data.knowledgeSourceIds);
          setIsFullReindex(res.data.isFullReindex);
          setPaused(res.data.paused);
        })
      : axios
          .get(`/knowledgesource/batchreindex/${props.scheduleId}`,{ withCredentials:true })
          .then((res) => {
            setSchedule(res.data);
            setScheduleName(res.data.scheduleName);
            setScheduleDescription(res.data.scheduleDescription);
            setCronExpression(res.data.cronExpression);
            setKsIds(res.data.knowledgeSourceIds);
            setIsFullReindex(res.data.isFullReindex);
            setPaused(res.data.paused);
          });
  }, []);

  useEffect(
    () => {
      props.scheduleId &&
        axios
          .get(`/knowledgesource/batchreindex/${props.scheduleId}`,{ withCredentials:true })
          .then((res) => {
            setSchedule(res.data);
            setScheduleName(res.data.scheduleName);
            setScheduleDescription(res.data.scheduleDescription);
            setCronExpression(res.data.cronExpression);
            setKsIds(res.data.knowledgeSourceIds);
            setIsFullReindex(res.data.isFullReindex);
            setPaused(res.data.paused);
          });
    },
    [props.scheduleId]
  );
  const stringCron = () => {
    if (cronExpression && cronExpression != "") {
      return cronstrue.toString(cronExpression);
    }
  };
  const knowledgeSourceSelected = (rows) => {
    setKsIds(rows.map((row) => row.id));
  };

  const [columns] = useState([
    {
      title: "id",
      field: "data.sourceId",
      hidden: true,
    },
    {
      title: t("manage_ks_description_table_header"),
      field: "data.description",
    },
    {
      title: t("global_topic"),
      field: "data.topicName",
    },
    {
      title: t("manage_ks_type_table_header"),
      field: "data.type",
      lookup: {
        EXPERT: "Expert",
        GOOGLE_DRIVE: "Google Drive",
        FILE_SHARE: "File Share",
        SHAREPOINT: "SharePoint",
        ONEDRIVE: "OneDrive",
        SALESFORCE: "Salesforce",
        WEBSITE: "Website",
        DROPBOX: "Dropbox",
      },
    },
    {
      title: t("manage_ks_indexed"),
      type: "boolean",
      render: (rowData) => {
        if (rowData.data.isQueued || rowData.data.isBeingIndexed) {
          return <JobProgress triggerName={rowData.data.jobTriggerName} />;
        }
        if (
          !rowData.data.dateReindexed ||
          rowData.data.dateReindexed === "1970-01-01 00:00:00"
        ) {
          return <ClearIcon />;
        }
        return <DoneIcon />;
      },
    },
    {
      title: t("manage_ks_last_indexed"),
      field: "data.dateReindexed",
      type: "datetime",
      editable: "never",
      render: (rowData) => {
        if (rowData.data.dateReindexed === 0) {
          return null;
        }
        return rowData.data.dateReindexed;
      },
    },
  ]);

  const updateSchedule = () => {
    setSaving(true);
    axios
      .patch("/knowledgesource/batchreindex/", {
        scheduleId: schedule.scheduleId,
        scheduleName: scheduleName,
        scheduleDescription: scheduleDescription,
        cronExpression: cronExpression,
        knowledgeSourceIds: ksIds,
        isFullReindex: isFullReindex,
      })
      .then((res) => {
        enqueueSnackbar(t("schedule_successfully_updated"), {
          variant: "success",
        });
        setSaving(false);
        setUpdateDialog(false);
        props.updateValues(res.data);
      })
      .catch((err) => {
        enqueueSnackbar(
          t("error_updating_schedule") + ": " + err.response.data.message,
          {
            variant: "error",
          }
        );
        setSaving(false);
      });
  };

  const deleteSchedule = () => {
    setDeleting(true);
    axios
      .delete(`/knowledgesource/batchreindex/${schedule.scheduleId}`)
      .then(() => {
        enqueueSnackbar(t("schedule_successfully_deleted"), {
          variant: "success",
        });
        setDeleting(false);
        setDeletionDialog(false);
        props.updateList();
      })
      .catch((err) => {
        enqueueSnackbar(
          t("error_deleting_schedule") + ": " + err.response.data.message,
          {
            variant: "error",
          }
        );
        setDeleting(false);
      });
  };

  const pauseSchedule = () => {
    setPausing(true);
    axios
      .patch(`/knowledgesource/batchreindex/${schedule.scheduleId}/pause`)
      .then(() => {
        enqueueSnackbar(t("schedule_successfully_paused"), {
          variant: "success",
        });
        setPausing(false);
        setPauseDialog(false);
        setPaused(!paused);
        props.updateList();
      })
      .catch((err) => {
        enqueueSnackbar(
          t("error_pausing_schedule") + ": " + err.response.data.message,
          {
            variant: "error",
          }
        );
        setPausing(false);
      });
  };

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <Typography variant="h5" style={{ marginRight: 10 }}>
          {props.default ? t("default_schedule") : scheduleName}
        </Typography>
        <ActionButton
          style={{ marginRight: 10 }}
          variant="contained"
          color="primary"
          onClick={() => setUpdateDialog(true)}
          loading={saving}
        >
          {t("global_update")}
        </ActionButton>
        <ActionButton
          style={{ marginRight: 10 }}
          variant="contained"
          color="primary"
          onClick={() => setPauseDialog(true)}
          loading={pausing}
        >
          {paused ? "Resume" : "Pause"}
        </ActionButton>
        <ActionButton
          variant="contained"
          color="primary"
          onClick={() => setCreateCronExpressionOpen(true)}
          style={{ marginRight: "10px" }}
        >
          {"Select interval"}
        </ActionButton>
        {!props.default && (
          <ActionButton
            variant="contained"
            color="primary"
            onClick={() => setDeletionDialog(true)}
            loading={deleting}
          >
            {t("global_delete")}
          </ActionButton>
        )}
      </div>
      <div className={classes.inputFields}>
        <TextField
          style={{ marginRight: 10 }}
          required
          value={scheduleName}
          onChange={(title) => setScheduleName(title.target.value)}
          label={t("schedule_name")}
          disabled={props.default}
        />
        <TextField
          style={{ marginRight: 10 }}
          value={scheduleDescription}
          onChange={(description) =>
            setScheduleDescription(description.target.value)
          }
          label={t("schedule_description")}
          disabled={props.default}
        />
        <FormControlLabel
          style={{ marginRight: 20 }}
          value="isFullReindex"
          control={
            <Checkbox
              checked={isFullReindex}
              onChange={() => setIsFullReindex(!isFullReindex)}
              value={t("global_full_reindex") + "?"}
            />
          }
          label={t("global_full_reindex") + "?"}
        />
        {/* <TextField
          style={{ marginRight: 10 }}
          required
          value={cronExpression}
          onChange={(cron) => setCronExpression(cron.target.value)}
          label={t("cron_expression")}
        /> */}
        <Typography variant="subtitle1" style={{ marginTop: "10px" }}>
          {stringCron()}
        </Typography>
        {/* <Link
          style={{ marginTop: 15 }}
          href="https://support.kpsol.com/support/crongenerator/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Click here to go to the cron expression generator
        </Link> */}
      </div>
      {/* <Scheduler
        cron={cronExpression}
        setCron={setCronExpression}
        setCronError={setCronError}
        isAdmin={true}
      /> */}
      {/* <Cron
        onChange={setCronExpression}
        value={cronExpression}
        showResultText={true}
        showResultCron={true}
      /> */}
      <div
        style={{ overflow: "auto", padding: 10, height: "100%", marginTop: 10 }}
      >
        <MaterialTable
          isLoading={loading}
          columns={columns}
          data={data.map((d) => {
            if (ksIds.indexOf(d.id) > -1) {
              return { ...d, tableData: { ...d.tableData, checked: true } };
            }
            return d;
          })}
          onSelectionChange={knowledgeSourceSelected}
          options={{
            pageSize: 10,
            pageSizeOptions: [5, 10, 15, 20],
            filtering: true,
            headerStyle: { position: "sticky", top: 0 },
            actionsColumnIndex: -1,
            selection: true,
          }}
          title={t("global_knowledge_source_plural")}
        />
      </div>
      <AreYouSureDialog
        open={deletionDialog}
        onClose={() => setDeletionDialog(false)}
        onSubmit={deleteSchedule}
      >
        {t("are_you_sure_delete_schedule")}
      </AreYouSureDialog>
      <AreYouSureDialog
        open={updateDialog}
        onClose={() => setUpdateDialog(false)}
        onSubmit={updateSchedule}
      >
        {t("are_you_sure_update_schedule")}
      </AreYouSureDialog>
      <AreYouSureDialog
        open={pauseDialog}
        onClose={() => setPauseDialog(false)}
        onSubmit={pauseSchedule}
      >
        {paused
          ? "Are you you want to resume this schedule?"
          : "Are you you want to pause this schedule?"}
      </AreYouSureDialog>
      <CreateCronExpression
        open={createCronExpressionOpen}
        close={() => setCreateCronExpressionOpen(false)}
        onAccept={(cron) => {
          let cronString = "";
          cron.map((item) => {
            cronString = cronString + item + " ";
          });
          setCronExpression(cronString);
          setCreateCronExpressionOpen(false);
        }}
      />
    </div>
  );
}

export default KnowledgeSourceCronSchedule;
